import { EExchangeType } from "@domains/features/Markets/Equity/entities/iTopGainersLosers";
export var SearchAssetTypeEnum;
(function (SearchAssetTypeEnum) {
    SearchAssetTypeEnum["Equity"] = "Equity";
    SearchAssetTypeEnum["Future"] = "Future";
    SearchAssetTypeEnum["Option"] = "Option";
    SearchAssetTypeEnum["MF"] = "MF";
    SearchAssetTypeEnum["PrimaryMarket"] = "PrimaryMarket";
    SearchAssetTypeEnum["ComFut"] = "COMFUT";
    SearchAssetTypeEnum["ComOpt"] = "COMOPT";
    SearchAssetTypeEnum["CurFut"] = "CURFUT";
    SearchAssetTypeEnum["CurOpt"] = "CUROPT";
    SearchAssetTypeEnum["ETFs"] = "ETFs";
    SearchAssetTypeEnum["Indices"] = "Indices";
    SearchAssetTypeEnum["NcdSecondary"] = "NcdSecondary";
    // SGB = "SGB",
    // CORPFD = "CORPFD",
})(SearchAssetTypeEnum || (SearchAssetTypeEnum = {}));
export var SearchAssetTypeNameEnum;
(function (SearchAssetTypeNameEnum) {
    SearchAssetTypeNameEnum["Equity"] = "EQ";
    SearchAssetTypeNameEnum["Future"] = "FUT";
    SearchAssetTypeNameEnum["Option"] = "OPT";
    SearchAssetTypeNameEnum["MF"] = "MF";
    SearchAssetTypeNameEnum["PrimaryMarket"] = "PRIMARY MRK";
    SearchAssetTypeNameEnum["COMFUT"] = "COMFUT";
    SearchAssetTypeNameEnum["COMOPT"] = "COMOPT";
    SearchAssetTypeNameEnum["CURFUT"] = "CURFUT";
    SearchAssetTypeNameEnum["CUROPT"] = "CUROPT";
    SearchAssetTypeNameEnum["ETFs"] = "ETF";
    SearchAssetTypeNameEnum["Indices"] = "INDICES";
    SearchAssetTypeNameEnum["NcdSecondary"] = "NCD";
})(SearchAssetTypeNameEnum || (SearchAssetTypeNameEnum = {}));
export var SearchPrimaryMarketType;
(function (SearchPrimaryMarketType) {
    SearchPrimaryMarketType["IPO"] = "IPO";
    SearchPrimaryMarketType["NCD"] = "NCD";
    SearchPrimaryMarketType["NFO"] = "NFO";
    SearchPrimaryMarketType["OFS"] = "OFS";
})(SearchPrimaryMarketType || (SearchPrimaryMarketType = {}));
export var CallPut;
(function (CallPut) {
    CallPut["CALL"] = "CE";
    CallPut["PUT"] = "PE";
})(CallPut || (CallPut = {}));
// adding constant here also as causing issue while importing in shared-library modules(same is also available in web module)
export var activeSectionOptions = {
    threshold: 0,
    delay: 1000,
};
export var dropDownCallPut = [
    {
        display: "Calls",
        value: CallPut.CALL,
    },
    {
        display: "Puts",
        value: CallPut.PUT,
    },
];
export var searchFilters = [
    {
        filterName: SearchAssetTypeEnum.Equity,
        eventKey: SearchAssetTypeEnum.Equity,
        list: [
            { title: "NSE ", key: EExchangeType.NSE, selected: true },
            { title: " BSE", key: EExchangeType.BSE, selected: true },
        ],
        selectType: "checkbox",
    },
    // {
    //   filterName: SearchAssetTypeEnum.Currency,
    //   eventKey: SearchAssetTypeEnum.Currency,
    //   list: [
    //     { title: "FUT", key: "FUT", selected: false },
    //     { title: "OPT", key: "OPT", selected: false },
    //   ],
    //   selectType: "select",
    // },
    {
        filterName: SearchAssetTypeEnum.ComOpt,
        eventKey: SearchAssetTypeEnum.ComOpt,
        list: [
            { title: "MCX", key: "MCX", selected: false },
            { title: "NCDEX", key: "NCDEX", selected: false },
        ],
        selectType: "checkbox",
    },
    {
        filterName: SearchAssetTypeEnum.ComFut,
        eventKey: SearchAssetTypeEnum.ComFut,
        list: [
            { title: "MCX", key: "MCX", selected: false },
            { title: "NCDEX", key: "NCDEX", selected: false },
        ],
        selectType: "checkbox",
    },
    {
        filterName: SearchAssetTypeEnum.PrimaryMarket,
        eventKey: SearchAssetTypeEnum.PrimaryMarket,
        list: [
            { title: "IPO", key: "IPO", selected: false },
            { title: "NFO", key: "NFO", selected: false },
            { title: "NCD IPO", key: "NCD", selected: false },
            { title: "OFS", key: "OFS", selected: false },
        ],
        selectType: "checkbox",
    },
    {
        filterName: SearchAssetTypeEnum.MF,
        eventKey: SearchAssetTypeEnum.MF,
        list: [
            { title: "Equity", key: "Equity", selected: false },
            { title: "Debt", key: "Debt", selected: false },
            { title: "Hybrid", key: "Hybrid", selected: false },
            { title: "ELSS", key: "ELSS", selected: false },
            { title: "Other", key: "Other", selected: false },
        ],
        selectType: "checkbox",
    },
];
export var EPrimaryMarketStatus;
(function (EPrimaryMarketStatus) {
    EPrimaryMarketStatus["UPCOMING"] = "Upcoming";
    EPrimaryMarketStatus["ONGOING"] = "Ongoing";
    EPrimaryMarketStatus["ABOUT_TO_BE_LISTED"] = "About to be listed";
})(EPrimaryMarketStatus || (EPrimaryMarketStatus = {}));
